"use client";
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion'; 

// 1️⃣ استيراد الأيقونات من lucide-react
import { 
  Globe, 
  Mail, 
  Phone, 
  ArrowUpLeft,
  ArrowLeft,
  CheckCircle2,
  ChevronDown,
  ChevronUp,
  Server,
  Network
} from 'lucide-react';

// 2️⃣ استيراد أيقونات السوشيال ميديا والمتاجر من react-icons
import {
  FaFacebookF, 
  FaInstagram, 
  FaWhatsapp,
  FaYoutube
} from 'react-icons/fa';

export default function LaserJetHost() {
  // حالة التحكم في زر "عرض المزيد"
  const [isExpanded, setIsExpanded] = useState(false);
  const [isPbxExpanded, setIsPbxExpanded] = useState(false);

  // بيانات قسم الـ PBX
  const pbxData = {
    title: "حلول الـ PBX والاتصالات",
    englishTitle: "Communications",
    desc: "حلول اتصال متكاملة ومتقدمة صُممت خصيصاً للشركات، تتيح لك إدارة مكالماتك بفعالية واحترافية عالية.",
    subTitle: "مميزات خدمات الـ PBX والكول سنتر",
    features: [
      { text: "السنترال الذكي (IP-PBX) لربط الفروع والتحويلات." },
      { text: "الاستجابة الصوتية التفاعلية (IVR) لتوجيه المتصلين آلياً." },
      { text: "نظام إدارة صفوف الانتظار وتقنيات الانتظار المتقدمة." },
      { text: "تقارير أداء تفصيلية حول حجم المكالمات وكفاءة الموظفين." },
      { text: "تأسيس مراكز كول سنتر متكاملة بأعلى معايير الجودة." },
      { text: "دعم تقني مستمر لضمان استقرار وتحديث الأنظمة." }
    ],
    extraSection: {
      title: "لماذا تعتمد حلولنا للاتصالات؟",
      items: ["تحسين تجربة العميل وسرعة الوصول", "زيادة إنتاجية وتنظيم سير العمل", "مرونة تقنية قابلة للتطوير"]
    }
  };

  // مصفوفة بيانات الروابط الأساسية السريعة لخدمة الاستضافة
  const contactLinks = [
    {
      id: 1,
      label: "منصة ليزرجيت هوست الإلكترونية",
      value: "host.laserjet.com.eg",
      href: "https://host.laserjet.com.eg",
      icon: <Globe className="w-5 h-5 text-[#004aad]" />
    },
    {
      id: 2,
      label: "البريد الإلكتروني للدعم التقني",
      value: "host@laserjet.com.eg",
      href: "mailto:host@laserjet.com.eg",
      icon: <Mail className="w-5 h-5 text-[#004aad]" />
    },
    {
      id: 3,
      label: "رقم خدمة العملاء والمبيعات",
      value: "01004331113",
      href: "tel:01004331113",
      icon: <Phone className="w-5 h-5 text-[#004aad]" />
    }
  ];

  // مصفوفة السوشيال ميديا 
  const socialLinks = [
    { id: 1, name: "فيسبوك", href: "https://www.facebook.com/laserjet.com.eg", icon: <FaFacebookF className="w-5 h-5" />, color: "bg-[#3b5998] text-white border-transparent hover:scale-105" },
    { id: 2, name: "واتساب المباشر", href: "https://wa.me/+201004331113", icon: <FaWhatsapp className="w-5 h-5" />, color: "bg-[#25D366] text-white border-transparent hover:scale-105" },
    { id: 3, name: "إنستغرام", href: "https://www.instagram.com/laserjet.com.eg/", icon: <FaInstagram className="w-5 h-5" />, color: "bg-gradient-to-tr from-[#f9ce34] via-[#ee2a7b] to-[#6228d7] text-white border-transparent hover:scale-105" },
    { id: 4, name: "قناة واتساب", href: "https://whatsapp.com/channel/0029Va23H37GufIsQw29xG0a", icon: <FaWhatsapp className="w-5 h-5" />, color: "bg-[#25D366] text-white border-transparent hover:scale-105" },
    { id: 5, name: "يوتيوب", href: "https://www.youtube.com/@laserjet2458", icon: <FaYoutube className="w-5 h-5" />, color: "bg-[#ff0000] text-white border-transparent hover:scale-105" },
  ];

  // مصفوفة الخدمات السحابية والاستضافة
  const servicesPortfolio = [
    { title: "حجز وإدارة النطاقات (Domains)", desc: "سجل اسم نطاق شركتك (.com, .net, .eg) بسهولة، مع خدمات إدارة وتجديد تلقائي لضمان تواجدك الدائم." },
    { title: "خوادم افتراضية خاصة (VPS)", desc: "خوادم ويندوز ولينكس عالية الأداء توفر لك التحكم الكامل، المرونة، والسرعة اللازمة لتشغيل تطبيقاتك الحساسة." },
    { title: "شهادات الحماية (SSL Certificates)", desc: "عزز ثقة عملائك وقم بتأمين بيانات موقعك من خلال شهادات تشفير عالمية تضمن سرية تبادل المعلومات." },
    { title: "بريد إلكتروني للأعمال (Business Email)", desc: "عزز هوية شركتك ببريد رسمي باسم النطاق الخاص بك، لضمان تواصل احترافي وموثوق مع عملائك." },
    { title: "حلول مايكروسوفت (Microsoft Solutions)", desc: "توفير التراخيص الرسمية والدعم الفني لمنصات وأدوات الإنتاجية العالمية المتكاملة من Microsoft." },
    { title: "تطوير الويب وأنظمة الشركات (Web & ERP Systems)", desc: "تصميم وتطوير المواقع التعريفية والأنظمة الإدارية المتكاملة التي تلبي احتياجات شركتك التشغيلية وتطور كفاءتها." }
  ];

  // مصفوفة نقاط القوة والتميز
  const advantages = [
    { title: "أداء مستقر وملتزم", desc: "خوادم مجهزة بأحدث التقنيات لضمان بقاء موقعك وتطبيقاتك متاحة على مدار الساعة بدون انقطاع." },
    { title: "أمان سيبراني فائق", desc: "بروتوكولات حماية متطورة وجدران نارية لحماية بيانات شركتك الحساسة من كافة التهديدات الرقمية." },
    { title: "دعم فني متخصص 24/7", desc: "فريق تقني متواجد دائماً لدعمك في إدارة الخوادم، إعداد الإيميلات، والتأكد من سير عملياتك بدون توقف." }
  ];

  return (
    <motion.section 
      initial={{ y: 30 }} 
      whileInView={{ opacity: 1, y: 0 }} 
      viewport={{ once: true, margin: "-100px" }} 
      transition={{ duration: 0.6, ease: "easeOut" }} 
      className="w-full bg-[#f4f7fa] relative py-12 md:py-20 px-4 md:px-8 font-sans overflow-hidden min-h-screen flex items-center justify-center"
      dir="rtl"
    >
      {/* الخلفية الهندسية المخصصة */}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#004aad05_1px,transparent_1px),linear-gradient(to_bottom,#004aad05_1px,transparent_1px)] bg-[size:36px_36px]" />
        <div className="absolute top-0 right-1/4 w-[400px] h-[400px] bg-[#004aad]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] bg-sky-400/10 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto w-full relative z-10">
        
        {/* تقسيم الشاشة */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          
          {/* جهة اليمين: تفاصيل الخدمة وقنوات التواصل */}
          <div className="space-y-6 w-full overflow-hidden">
            
            {/* بلوك تفاصيل الخدمة المطورة */}
            <div className="space-y-5 text-right bg-white p-5 sm:p-8 rounded-[2rem] border border-gray-100 shadow-[0_15px_40px_-20px_rgba(0,0,0,0.05)]">
              
              {/* اسم الخدمة */}
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-black text-[#004aad] tracking-wide flex flex-wrap items-center gap-2 sm:gap-3">
                <span className="whitespace-nowrap">ليزرجيت هوست</span>
                <span className="text-gray-300 font-light hidden sm:inline">|</span>
                <span className="font-extrabold text-transparent bg-clip-text bg-gradient-to-l from-[#004aad] to-sky-600 font-mono tracking-tight break-all">LaserJet Host</span>
              </h3>
              
              {/* خط فاصل أنيق */}
              <div className="w-full h-[2px] bg-gradient-to-r from-[#004aad]/20 via-gray-200 to-transparent rounded-full my-3" />
              
              {/* وصف الخدمة */}
              <p className="text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed font-medium">
                بنيتك التحتية الرقمية الأكثر أماناً واستقراراً. نقدم حلول استضافة متكاملة وخدمات سحابية فائقة السرعة، مصممة خصيصاً لتمكين الشركات والأفراد من التواجد الرقمي المستمر بأعلى درجات الموثوقية والكفاءة التشغيلية.
              </p>

              {/* زر عرض المزيد / أقل */}
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="flex items-center gap-2 text-xs sm:text-sm font-bold text-[#004aad] hover:text-sky-700 transition-colors mt-2 focus:outline-none group/toggle text-right"
              >
                <span>{isExpanded ? "عرض تفاصيل أقل" : "عرض محفظة الخدمات السحابية ومميزات الاستضافة"}</span>
                {isExpanded ? (
                  <ChevronUp className="w-4 h-4 shrink-0 transition-transform group-hover/toggle:-translate-y-0.5" />
                ) : (
                  <ChevronDown className="w-4 h-4 shrink-0 transition-transform group-hover/toggle:translate-y-0.5" />
                )}
              </button>

              {/* المحتوى القابل للتمدد والانكماش */}
              <AnimatePresence initial={false}>
                {isExpanded && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                    className="overflow-hidden space-y-6 pt-2"
                  >
                    {/* محفظة خدمات الاستضافة */}
                    <div className="space-y-3">
                      <h4 className="text-xs sm:text-sm font-bold text-gray-800 border-r-2 border-[#004aad] pr-2">محفظة خدمات الاستضافة والحلول الرقمية</h4>
                      <div className="grid grid-cols-1 gap-2.5">
                        {servicesPortfolio.map((serv, idx) => (
                          <div key={idx} className="flex items-start gap-2.5 bg-slate-50/50 p-3 rounded-xl border border-gray-100 shadow-sm">
                            <CheckCircle2 className="w-5 h-5 text-[#004aad] shrink-0 mt-0.5" />
                            <div>
                              <p className="text-xs sm:text-sm font-bold text-gray-800">{serv.title}</p>
                              <p className="text-[11px] sm:text-xs text-gray-500 mt-0.5 leading-relaxed">{serv.desc}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* لماذا تختار ليزرجيت هوست */}
                    <div className="space-y-3">
                      <h4 className="text-xs sm:text-sm font-bold text-gray-800 border-r-2 border-emerald-500 pr-2">لماذا تختار "ليزرجيت هوست"</h4>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                        {advantages.map((adv, idx) => (
                          <div key={idx} className="p-3 bg-gradient-to-br from-white to-gray-50 border border-gray-200 rounded-xl shadow-sm">
                            <p className="text-[11px] sm:text-xs font-bold text-gray-800 flex items-center gap-1.5">
                              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 shrink-0" />
                              {adv.title}
                            </p>
                            <p className="text-[10px] sm:text-[11px] text-gray-500 mt-1 leading-relaxed">{adv.desc}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>

              {/* لينك تصفح خطط السيرفرات */}
              <div className="pt-2">
                <a 
                  href="https://host.laserjet.com.eg" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 text-xs sm:text-sm font-bold text-[#004aad] hover:text-sky-700 transition-colors group/btn bg-[#004aad]/5 px-4 sm:px-5 py-2.5 rounded-xl border border-[#004aad]/10 hover:bg-[#004aad]/10 w-full sm:w-auto"
                >
                  <Server className="w-4 h-4 text-[#004aad] shrink-0" />
                  <span>تصفح خطط السيرفرات والخدمات السحابية</span>
                  <ArrowLeft className="w-4 h-4 transition-transform duration-300 group-hover/btn:-translate-x-1 mr-auto sm:mr-2 shrink-0" />
                </a>
              </div>

              {/* خط فاصل بين القسمين */}
              <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-gray-200 to-transparent my-6" />

              {/* قسم الـ PBX كخدمة فرعية */}
              <div className="space-y-4 text-right mt-4">
                <h3 className="text-xl sm:text-2xl font-black text-[#004aad] tracking-wide flex flex-wrap items-center gap-2">
                  <Network className="w-5 h-5 sm:w-6 h-6 text-[#004aad] shrink-0" />
                  <span>{pbxData.title}</span>
                  <span className="text-xs sm:text-sm text-gray-400 font-mono font-medium tracking-normal">({pbxData.englishTitle})</span>
                </h3>
                
                <p className="text-gray-600 text-xs sm:text-sm md:text-base leading-relaxed font-medium">
                  {pbxData.desc}
                </p>

                <button
                  onClick={() => setIsPbxExpanded(!isPbxExpanded)}
                  className="flex items-center gap-2 text-xs sm:text-sm font-bold text-[#004aad] hover:text-sky-700 transition-colors mt-1 focus:outline-none group/toggle text-right"
                >
                  <span>{isPbxExpanded ? "عرض تفاصيل أقل" : "عرض مميزات وتفاصيل خدمة الـ PBX"}</span>
                  {isPbxExpanded ? (
                    <ChevronUp className="w-4 h-4 shrink-0 transition-transform group-hover/toggle:-translate-y-0.5" />
                  ) : (
                    <ChevronDown className="w-4 h-4 shrink-0 transition-transform group-hover/toggle:translate-y-0.5" />
                  )}
                </button>

                <AnimatePresence initial={false}>
                  {isPbxExpanded && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: "easeInOut" }}
                      className="overflow-hidden space-y-6 pt-2"
                    >
                      <div className="space-y-3">
                        <h4 className="text-xs sm:text-sm font-bold text-gray-800 border-r-2 border-[#004aad] pr-2">{pbxData.subTitle}</h4>
                        <div className="grid grid-cols-1 gap-2.5">
                          {pbxData.features.map((feat, idx) => (
                            <div key={idx} className="flex items-start gap-2.5 bg-slate-50/50 p-3 rounded-xl border border-gray-100 shadow-sm">
                              <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-[#004aad] shrink-0 mt-0.5" />
                              <div>
                                <p className="text-xs sm:text-sm font-bold text-gray-800">{feat.text}</p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="space-y-3">
                        <h4 className="text-xs sm:text-sm font-bold text-gray-800 border-r-2 border-emerald-500 pr-2">{pbxData.extraSection.title}</h4>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                          {pbxData.extraSection.items.map((item, idx) => (
                            <div key={idx} className="p-3 bg-gradient-to-br from-white to-gray-50 border border-gray-200 rounded-xl shadow-sm">
                              <p className="text-[11px] sm:text-xs font-bold text-gray-800 flex items-center gap-1.5">
                                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 shrink-0" />
                                {item}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>

            </div>

            {/* كروت الروابط السريعة */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {contactLinks.map((item) => (
  <a
    key={item.id}
    href={item.href}
    target="_blank"
    rel="noopener noreferrer"
    className="flex items-center gap-3 p-3.5 rounded-2xl bg-white border border-gray-200 text-gray-800 hover:bg-gray-50 hover:border-[#004aad]/30 hover:shadow-sm transition-all duration-300 group/item overflow-hidden"
  >
    {/* 1. السهم في البداية (على الشمال) */}
    <ArrowUpLeft className="w-3.5 h-3.5 text-gray-400 group-hover/item:text-[#004aad] group-hover/item:-translate-x-0.5 group-hover/item:-translate-y-0.5 transition-all shrink-0" />
    
    {/* 2. النصوص بتاخد المساحة اللي في النص كاملة */}
    <div className="text-right overflow-hidden flex-1 min-w-0">
      <p className="text-[10px] sm:text-[11px] text-gray-400 font-medium mb-0.5 truncate">{item.label}</p>
      <p className="text-xs font-bold text-gray-700 truncate tracking-wide text-left" dir="ltr">{item.value}</p>
    </div>

    {/* 3. الأيقونة في النهاية (على اليمين) */}
    <div className="w-9 h-9 rounded-xl bg-gray-100 flex items-center justify-center shrink-0 group-hover/item:bg-[#004aad]/10 transition-colors">
      {item.icon}
    </div>
  </a>
))}
            </div>

            {/* أزرار السوشيال ميديا */}
            <div className="p-4 sm:p-5 rounded-2xl bg-white border border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3.5 shadow-sm">
              <h4 className="text-xs sm:text-sm font-bold text-gray-500">تابعنا لتصلك أحدث العروض والخدمات التقنية:</h4>
              <div className="flex flex-wrap gap-2">
                {socialLinks.map((social) => (
                  <a
                    key={social.id}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={social.name}
                    className={`w-9 h-9 sm:w-10 sm:h-10 rounded-xl flex items-center justify-center transition-all duration-300 transform hover:-translate-y-0.5 shadow-sm border ${social.color}`}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

          </div>

          {/* جهة اليسار: كارت الصورة الفخم بدون خلفية بيضاء على الموبايل */}
          <div className="w-full flex flex-col items-center lg:items-end lg:sticky lg:top-24 mt-4 lg:mt-10 gap-6">
            
            {/* تم جعل الحاوية شفافة تماماً على الموبايل وبخلفية بيضاء خفيفة فقط على الشاشات الكبيرة */}
            <div className="w-full max-w-[500px] h-[260px] sm:h-[440px] rounded-[2.5rem] overflow-hidden relative sm:shadow-[0_20px_50px_-12px_rgba(0,0,0,0.08)] sm:border sm:border-gray-200 group/card sm:bg-white flex items-center justify-center p-0">
              <img 
                src="/laserhost.jpeg" 
                alt="LaserJet Service Display" 
                className="w-full h-full object-contain sm:object-cover transition-transform duration-700 ease-out group-hover/card:scale-103 select-none pointer-events-none rounded-[2.5rem] sm:rounded-none"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/10 via-transparent to-transparent z-10 pointer-events-none rounded-[2.5rem]" />
              
              <div className="absolute bottom-4 right-4 sm:bottom-6 sm:right-6 z-20 bg-white/95 backdrop-blur-md px-3 py-1.5 sm:px-4 sm:py-2 rounded-xl text-gray-800 font-bold text-[10px] sm:text-xs border border-gray-200 shadow-sm">
                LaserJet Service
              </div>
            </div>

          </div>

        </div>

      </div>
    </motion.section>
  );
}